/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Async bootstrap boundary — Module Federation initialises its shared scope
// (React/ReactDOM singletons) asynchronously. Deferring the real app start
// behind a dynamic import guarantees the shared scope is ready before any React
// code runs, so a federated remote reuses the host's single React instance.
import("./bootstrap");
